import { jwtDecode } from "jwt-decode";

export class OauthAccessToken {

  private readonly _token: string;
  private readonly _tokenId: string;
  private readonly _eId: string;
  private readonly _clientNumber: string;
  private readonly _lastLoginTime: number;
  private readonly _firstName: string;
  private readonly _expirationDate: number;
  private readonly _cstoken: string;

  constructor(token: string) {
    const decodedToken: any = jwtDecode(token);
    this._token = token;
    this._tokenId = decodedToken["jti"];
    this._eId = decodedToken["eid"];
    this._clientNumber = decodedToken["clno"];
    this._lastLoginTime = decodedToken["lastLoginTime"]; // in seconds
    this._firstName =decodedToken["firstName"];
    this._expirationDate = decodedToken["exp"];
    this._cstoken = decodedToken["cstoken"];
  }


  get token(): string {
    return this._token;
  }

  get tokenId(): string {
    return this._tokenId;
  }

  get eId(): string {
    return this._eId;
  }

  get clientNumber(): string {
    return this._clientNumber;
  }

  get lastLoginTime(): number {
    return this._lastLoginTime;
  }

  get firstName(): string {
    return this._firstName?.length > 1 ? this._firstName : "";
  }

  get expirationDate(): number {
    return this._expirationDate;
  }

  get cstoken(): string {
    return this._cstoken;
  }

  public getLastLoginDate(): Date | null {
    return this._lastLoginTime ? new Date(this._lastLoginTime * 1000) : null;
  }

  public isTokenExpired():boolean{
    return Date.now()/1000 > this._expirationDate; //the expiry date value in token is in seconds, whereas the Date.now() gives you the time in milliseconds
  }
}
/* sample access token
 {
 "token_type": "Bearer",
 "iss": "https://authdev.icbc.com",
 "authlevel": "3",
 "clno": "01400085",
 "currentLoginTime": "1743096364",
 "eid": "338131134335194",
 "firstName": "TEST",
 "groups": [
 "public"
 ],
 "sub": "338131134335194",
 "jti": "c950aac472d28a089e5b1771a9ab7bd929ebd8d846e348fa25abd3e2d7444a52",
 "iat": 1743096365,
 "exp": 1743096665,
 "nbf": 1743096065
 }
 */
